import config from 'config';

import { useBreakpoint } from '~/techstyle-shared/react-components';

import useGridInputs from './useGridInputs';

const useNumGridCols = () => {
  const { columnVariant } = useGridInputs();
  let gridColumnSettings = config.get('public.brand.gridColumnSettings');

  gridColumnSettings =
    columnVariant && gridColumnSettings[columnVariant]
      ? gridColumnSettings[columnVariant]
      : gridColumnSettings.default;

  // original is 960px but causes products to overlap
  // consider adding padding to card and virtual row if we revert to 960px
  const { matches } = useBreakpoint('(max-width: 1100px)');

  return matches
    ? gridColumnSettings?.mobile?.columns || 2
    : gridColumnSettings?.desktop?.columns || 3;
};

export default useNumGridCols;
